// TFS App Hub permanent date standard — the ONE centralized date formatter.
// Date only: MM/DD/YY   |   Date+time: MM/DD/YY h:mm AM/PM ET   |   Range: MM/DD/YY–MM/DD/YY
// Storage stays ISO; this formats display ONLY. Date-only values are never shifted by UTC.

export const fmtDate = (v) => {
  if (!v) return '';
  // A 10-char date-only string (YYYY-MM-DD) is anchored to local midnight so the
  // calendar day never shifts across time zones.
  const d = new Date(typeof v === 'string' && v.length === 10 ? v + 'T00:00:00' : v);
  if (isNaN(d)) return '';
  return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
};

// MM/DD/YY h:mm AM/PM ET — timestamps rendered in Miami/Eastern time.
export const fmtDateTime = (v) => {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d)) return '';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: '2-digit',
    hour: 'numeric', minute: '2-digit', hour12: true,
  }).formatToParts(d);
  const g = (t) => (parts.find((p) => p.type === t) || {}).value || '';
  return `${g('month')}/${g('day')}/${g('year')} ${g('hour')}:${g('minute')} ${g('dayPeriod')} ET`;
};

// MM/DD/YY–MM/DD/YY (single date if start === end or one side blank).
export const fmtRange = (start, end) => {
  const s = fmtDate(start);
  const e = fmtDate(end);
  if (s && e && s !== e) return `${s}\u2013${e}`;
  return s || e || '';
};

// Swap any embedded ISO date substrings (YYYY-MM-DD) inside free text (e.g. work-order
// titles like "Historical Service — Grove (2026-07-20)") to the MM/DD/YY standard.
// Storage is untouched; this transforms display text only.
export const humanizeDates = (text) => {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, (_m, y, mo, d) => `${mo}/${d}/${y.slice(-2)}`);
};

// Placeholder text for date inputs, per standard.
export const DATE_PLACEHOLDER = 'MM/DD/YY';
